import Shepherd from 'shepherd.js';
if($('.network-administration-pipelines').length){

    ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
        var data = {
            'page': 'network-administration-pipelines-1'
        };
        axios.post("/api/v1/onboarding", data)
        .then((response) =>  {
        }).catch(function (error) {
            console.log('onboarding logged')
        });
    }));

    var dataType = $('.network-administration-pipelines').attr('data-type');
    
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });
    
    tour.addStep({
        title: 'Introduction to Pipelines',
        text: "Pipelines give you the ability to manage and track your applications as they go through your company's own internal processes. This guide will take you through how pipelines work and how to use them.",
        buttons: [
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-1'
    });
    
    tour.addStep({
        title: 'Switching pipeline',
        text: "If you have both Innovation and Expert applications enabled, you have an option between three types of pipelines (All, Innovations and Experts). If you select All, this disables the other two. If you select either Innovations or Experts, you can switch between them, using the dropdown in the top right.",
        attachTo: {
            element: '.input-field #applicationType',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });
    
    tour.addStep({
        title: 'Adding a stage',
        text: "You should create a stage for every step in your internal processes of onboarding new innovations or experts from your applications. You can add as many stages as you like, once you add a few, you'll need to scroll horizontally to see them. Please create two stages now to be taken to the next part of this guide.",
        attachTo: {
            element: '.add-stage',
            on: 'right'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.complete();
                },
                classes: 'btn btn--secondary',
                text: 'Finish'
            }
        ],
        id: 'step-3'
    });

    if(!$('.onboarding-network-administration-pipelines-1').length){
        tour.start();
    }
}
